import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { testimonials } from '@/mocks/articles';

export default function About() {
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.51chigua.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.51chigua.com/about' },
    ],
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '五一吃瓜网',
    url: 'https://www.51chigua.com',
    description: '五一吃瓜网 - 吃瓜第一站，专注网红明星黑料爆料的实时追踪平台。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'contact@51chigua.com',
      availableLanguage: ['Chinese'],
    },
  };

  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于五一吃瓜网',
    description: '了解五一吃瓜网的品牌故事、团队理念与核心价值观。真相·速度·态度。',
    url: 'https://www.51chigua.com/about',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '五一吃瓜网的内容来源是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容来自专业记者团队的一手采访、权威渠道的信息整合以及用户的真实爆料，所有内容均经过严格的核实流程。',
        },
      },
      {
        '@type': 'Question',
        name: '如何下载五一吃瓜网APP？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以在本网站底部的下载区域找到APP下载入口，支持iOS和Android两大平台。',
        },
      },
      {
        '@type': 'Question',
        name: '如何向五一吃瓜网提供爆料线索？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过网站底部的联系邮箱发送爆料线索，我们会在24小时内进行处理和回复。',
        },
      },
      {
        '@type': 'Question',
        name: '五一吃瓜网的内容多久更新一次？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的内容团队全天候运作，重大爆料事件发生后15分钟内即可发布快讯，深度报道在核实后24小时内上线。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />

      <main>
        <section className="relative w-full pt-24 pb-12 md:pt-32 md:pb-16 px-4 md:px-6 text-center">
          <div className="max-w-4xl mx-auto">
            <nav className="flex items-center justify-center gap-2 text-xs text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-foreground-950 transition-colors">首页</Link>
              <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-s-line"></i></span>
              <span className="text-foreground-950 font-medium">关于我们</span>
            </nav>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight">
              关于五一吃瓜网
            </h1>
            <p className="text-xl md:text-2xl font-heading font-bold text-foreground-700 mt-3">
              真相 · 速度 · 态度
            </p>
            <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
              五一吃瓜网致力于成为中文互联网最值得信赖的娱乐资讯平台。我们以最快的速度、最准确的信息、最深度的报道，为每一位吃瓜群众提供优质的阅读体验。
            </p>
          </div>

          <div className="mt-10 max-w-5xl mx-auto">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20editorial%20newsroom%20with%20warm%20lighting%2C%20team%20of%20journalists%20working%20at%20desks%20with%20screens%2C%20collaborative%20atmosphere%2C%20professional%20media%20environment%2C%20clean%20modern%20office%20design%2C%20warm%20amber%20and%20neutral%20tones&width=1400&height=500&seq=about-hero-team-2026&orientation=landscape"
              alt="五一吃瓜网团队"
              className="w-full rounded-3xl h-52 md:h-72 lg:h-80 object-cover object-top"
            />
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 max-w-4xl mx-auto text-center">
          <div className="flex justify-center mb-8">
            <span className="px-4 py-1.5 border border-foreground-300 rounded-full text-xs font-medium text-foreground-600 whitespace-nowrap">
              品牌故事
            </span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-light text-foreground-950 leading-relaxed">
            从一个小小的吃瓜交流群，
          </h2>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-light text-foreground-950 leading-relaxed mt-2">
            到如今覆盖千万用户的娱乐资讯平台，
          </h2>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-light text-foreground-950 leading-relaxed mt-2">
            五一吃瓜网始终坚守一个信念：
          </h2>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-foreground-950 leading-relaxed mt-2">
            让吃瓜变得更简单、更真实、更有趣。
          </h2>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
            <div className="bg-background-100 rounded-2xl p-6 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <span className="w-6 h-6 flex items-center justify-center"><i className="ri-flashlight-line text-xl text-foreground-950"></i></span>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">速度第一</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们拥有7x24小时全天候运营团队，确保重大爆料事件在第一时间传递给用户。从事件发生到快讯发布，最快仅需15分钟。
              </p>
            </div>
            <div className="bg-background-100 rounded-2xl p-6 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <span className="w-6 h-6 flex items-center justify-center"><i className="ri-shield-check-line text-xl text-foreground-950"></i></span>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">真实为本</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                每一条爆料在发布前都经过严格的核实流程。我们坚持不传谣、不信谣，只发布经过多方交叉验证的真实信息。
              </p>
            </div>
            <div className="bg-background-100 rounded-2xl p-6 border border-background-200/60">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4">
                <span className="w-6 h-6 flex items-center justify-center"><i className="ri-heart-line text-xl text-foreground-950"></i></span>
              </div>
              <h3 className="text-lg font-semibold text-foreground-950 mb-2">用户至上</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                我们始终把用户需求放在第一位，持续优化产品体验。无论是APP还是网站，都力求让吃瓜变得更轻松、更愉快。
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6">
          <div className="max-w-4xl mx-auto">
            {testimonials.map((t, index) => (
              <div key={t.id} className={`bg-foreground-950 rounded-3xl p-8 md:p-10 ${index > 0 ? 'mt-6' : ''} relative overflow-hidden`}>
                <div className="relative z-10 flex flex-col md:flex-row gap-6 items-start">
                  <div className="w-32 h-16 rounded-xl overflow-hidden bg-background-50/10 flex-shrink-0 flex items-center justify-center p-3">
                    <img src={t.logo} alt={t.outlet} className="max-w-full max-h-full object-contain" loading="lazy" />
                  </div>
                  <div className="flex-1">
                    <span className="text-4xl md:text-5xl font-serif text-accent-100/40 leading-none block">&ldquo;</span>
                    <p className="text-background-50 text-base md:text-lg leading-relaxed -mt-2">{t.quote}</p>
                    <div className="flex items-center gap-3 mt-4 text-sm">
                      <span className="font-semibold text-background-50/80">{t.outlet}</span>
                      <span className="text-foreground-400">{t.date}</span>
                    </div>
                  </div>
                </div>
                <div className="absolute bottom-2 right-4 opacity-5 pointer-events-none select-none">
                  <span className="text-[100px] font-heading font-black leading-none">推荐</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 max-w-4xl mx-auto text-center">
          <div className="relative rounded-3xl overflow-hidden mb-12 md:mb-16">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20collaborative%20office%20space%20with%20glass%20walls%2C%20warm%20lighting%2C%20creative%20team%20working%20together%2C%20clean%20minimal%20design%2C%20professional%20corporate%20environment%2C%20warm%20neutral%20tones%20with%20amber%20accents&width=1400&height=600&seq=about-contact-office-2026&orientation=landscape"
              alt="联系我们"
              className="w-full h-auto rounded-3xl"
            />
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-relaxed">
            与我们
            <span className="text-foreground-400 italic font-light mx-2">一起成长</span>
          </h2>
          <p className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-relaxed mt-1">
            合作与联系
          </p>
          <p className="mt-4 text-sm text-foreground-600 max-w-lg mx-auto leading-relaxed">
            如果您有商业合作、内容投稿或爆料线索，欢迎通过以下方式联系我们。我们期待与您的交流与合作。
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:contact@51chigua.com"
              className="px-8 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap"
            >
              发送合作邮件
            </a>
            <Link
              to="/"
              className="px-8 py-3.5 border border-foreground-300 rounded-full text-sm font-medium text-foreground-700 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-300 whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>

          <div className="mt-16 bg-background-100 rounded-3xl p-8 md:p-10 border border-background-200/60">
            <h2 className="text-xl font-semibold text-foreground-950 mb-8">常见问题</h2>
            <div className="space-y-6 text-left">
              <div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">五一吃瓜网的内容来源是什么？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">我们的内容来自专业记者团队的一手采访、权威渠道的信息整合以及用户的真实爆料，所有内容均经过严格的核实流程。</p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">如何下载五一吃瓜网APP？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">您可以在本网站底部的下载区域找到APP下载入口，支持iOS和Android两大平台。</p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">如何向五一吃瓜网提供爆料线索？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">您可以通过网站底部的联系邮箱发送爆料线索，我们会在24小时内进行处理和回复。</p>
              </div>
              <div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">五一吃瓜网的内容多久更新一次？</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">我们的内容团队全天候运作，重大爆料事件发生后15分钟内即可发布快讯，深度报道在核实后24小时内上线。</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}